import axios from 'axios';

export default {
  fetchStatusesByType(type){
    let params ={type : type};
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/statuses/", {params})
      .then(results=>{
        return results.data;
      })
  }

}
